import { render, staticRenderFns } from "./ResizeableTitle.vue?vue&type=template&id=1b805a57"
import script from "./ResizeableTitle.vue?vue&type=script&lang=js"
export * from "./ResizeableTitle.vue?vue&type=script&lang=js"
import style0 from "./ResizeableTitle.vue?vue&type=style&index=0&id=1b805a57&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b805a57')) {
      api.createRecord('1b805a57', component.options)
    } else {
      api.reload('1b805a57', component.options)
    }
    module.hot.accept("./ResizeableTitle.vue?vue&type=template&id=1b805a57", function () {
      api.rerender('1b805a57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/ui/components/table/ResizeableTitle.vue"
export default component.exports